import React, { useContext } from "react";
import { Typography } from "@vp/swan";
import { BffDataContext } from "../../../../contexts/BffDataContextProvider";
import { PluginDataContext } from "../../../../pluginsInfrastructure/PluginDataContextProvider";

interface OutOfStockProps {}

const OutOfStock = (props: OutOfStockProps) => {
  const { temporarilyOutOfStock } = useContext(BffDataContext);
  const { pluginData } = useContext(PluginDataContext);

  const outOfStock = pluginData.contentful["outOfStock"];

  return (
    <>
      {temporarilyOutOfStock ? (
        <Typography
          fontWeight="bold"
          fontSize={"standard"}
          component="p"
          textColor="error"
          marginY={"3"}
        >
          {outOfStock}
        </Typography>
      ) : (
        undefined
      )}
    </>
  );
};

export default OutOfStock;
